<!-- 公司信息 -->
<template>
    <div v-if="componentsData.type == 12" class="bg-div"
        :style="componentsData.content.version ?
            {
                ...(componentsData.content.bg_color && { backgroundColor: componentsData.content.bg_color }),
                ...(componentsData.content.bg_img.picview && componentsData.content.bg_value && { backgroundImage: `url(${componentsData.content.bg_img.picview})` }),
                padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`
            } : 
            `padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;background: ${componentsData.content.bg_color};border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px`
        "
    >
        <div>
            <div class="header fw-bold" :style="`background: ${componentsData.content.title_bg_color};border-bottom: 1px solid ${componentsData.content.title_border_color};`">
                <img class="header-img" v-if="companyData.show_logo" :src="companyData.show_logo"/>
                <div :style="`font-size: ${componentsData.content.title_size}px;color: ${componentsData.content.title_color};`">
                    {{ companyData.company_name }}
                </div>
            </div>
            <div class="mt-6" :style="`font-size: ${componentsData.content.size}px;color: ${componentsData.content.text_color};`">
                <div>负责人：<span :style="`color: ${componentsData.content.txt_color};`">{{ companyData.contact }}</span></div>
                <div class="flex-sb">
                    <div>联系方式：<span :style="`color: ${componentsData.content.txt_color};`">{{ companyData.mobile }}</span></div>
                    <div class="footer-txt">一键拨号</div>
                </div>
                <div class="flex-sb">
                    <div>公司地址：<span :style="`color: ${componentsData.content.txt_color};`">{{ companyData.address }}</span></div>
                    <div class="footer-txt">一键导航</div>
                </div>
                <div>公司简介：<span :style="`color: ${componentsData.content.txt_color};`">{{ companyData.desc }}</span></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
        companyData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
.header {
    display: flex;
    align-items: center;
    padding-bottom: 6px;
}
.header-img {
    margin: 0 12px 0 0;
    width: 26px;
    min-width: 26px;
    max-width: 26px;
    height: 26px;
    min-height: 26px;
    max-height: 26px;
    border-radius: 8px;
}
.footer-txt {
    width: 44px;
    min-width: 44px;
    max-width: 44px;
    font-size: 11px;
    color: #1db85c;
}
.mt-6 {
    margin-top: 6px;
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.fw-bold {
    font-weight: bold;
}
</style>